import { useCallback } from 'react';

import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { TabName } from '@/features/administration/types';

const debugConfig = createDebugConfig();

export const getTabName = (index: number): TabName => {
    const tabNames: Record<number, TabName> = {
        0: 'personal_info',
        1: 'contact_details',
        2: 'invoice_details',
        3: 'documents',
    };

    return tabNames[index] ?? 'unknown';
};

export const useTabAnalytics = () => {
    const handleTabChange = useCallback((newTabIndex: number): void => {
        trackCustomEvent(
            'tab_select',
            {
                trigger: 'click',
                flow_name: 'charging_contract_tab',
                element_name: getTabName(newTabIndex),
            },
            debugConfig
        );
    }, []);

    return {
        handleTabChange,
    };
};
